import type { ReactNode } from 'react';
import { createContext, useContext, useRef } from 'react';

import type { Howl } from 'howler';

const SingleAudioTrackContext = createContext<{
  setPlayingTrack: (audio: Howl | undefined) => void;
  stopPlayingTrack: () => void;
}>({
  setPlayingTrack: () => {},
  stopPlayingTrack: () => {},
});

export const SingleAudioTrackProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const currentTrack = useRef<Howl | undefined>(undefined);

  const setPlayingTrack = (audio: Howl | undefined) => {
    if (currentTrack.current) {
      currentTrack.current.stop();
    }
    currentTrack.current = audio;
  };

  const stopPlayingTrack = () => {
    if (currentTrack.current) {
      currentTrack.current.stop();
    }
    currentTrack.current = undefined;
  };

  return (
    <SingleAudioTrackContext.Provider
      value={{ setPlayingTrack, stopPlayingTrack }}
    >
      {children}
    </SingleAudioTrackContext.Provider>
  );
};

export const useSingleAudioTrack = () => useContext(SingleAudioTrackContext);
